import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorias',
  templateUrl: './tutorias.component.html',
  styleUrls: ['./tutorias.component.css']
})
export class TutoriasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
